import { useDownloadFileResourceMutation } from "@/hooks/download-file-resource-mutation.hook";
import { cn } from "@/lib/utils";
import { Resource } from "@/types/resources";
import { DocumentDownload, Link1 } from "iconsax-react";
import { FC } from "react";

type RelevantDocumentsDropdownItemProps = {
  resourceLibraryId: string;
  resource: Resource;
};

const wrapperClassName =
  "group flex cursor-pointer items-center gap-2 rounded p-2 text-[#8090A3] hover:bg-secondary hover:text-primary";

const RelevantDocumentsDropdownItem: FC<RelevantDocumentsDropdownItemProps> = ({
  resourceLibraryId,
  resource,
}) => {
  const mutation = useDownloadFileResourceMutation();

  const handleFileDownload = () => {
    mutation.mutate({
      resourceLibraryId: resourceLibraryId,
      resourceId: resource.id,
      fileName: resource.name.endsWith(".pdf")
        ? resource.name
        : `${resource.name}.pdf`,
    });
  };

  if (resource.type === "FILE") {
    return (
      <button
        className={cn(wrapperClassName, "text-left")}
        onClick={() => handleFileDownload()}
      >
        <span className="grow text-xs font-medium">{resource.name}</span>
        <DocumentDownload size={20} className="shrink-0" />
      </button>
    );
  } else {
    return (
      <a
        className={wrapperClassName}
        href={resource.url}
        target="_blank"
        rel="noreferrer"
      >
        <span className="grow text-xs font-medium">{resource.name}</span>
        <Link1 size={20} className="shrink-0" />
      </a>
    );
  }
};

export default RelevantDocumentsDropdownItem;
